import React, { useEffect, useState } from "react";
import { TabContent, TabPane } from "reactstrap";

// context
import { useLayout } from "../../context/LayoutContext";

// constants
import { TABS } from "../../constants/index";

// component
import Profile from "./Profile/index";
import Chats from "./Chats/index";
import Robot from "./Robot/index";
import Contacts from "./Contacts/index";
import Calls from "./Calls/index";
import Bookmark from "./Bookmark/index";
import Settings from "./Settings/index";
import Templates from "./Templates";

const Leftbar = () => {
  const { activeTab } = useLayout(); // ⬅️ Vem do contexto

  return (
    <>
      <div className="chat-leftsidebar">
        <TabContent activeTab={activeTab}>
          <TabPane tabId={TABS.USERS} role="tabpanel">
            <Profile />
          </TabPane>

          <TabPane tabId={TABS.CHAT} role="tabpanel">
            <Chats />
          </TabPane>

          <TabPane tabId={TABS.CONTACTS} role="tabpanel">
            <Contacts />
          </TabPane>

          <TabPane tabId={TABS.CALLS} role="tabpanel">
            <Calls />
          </TabPane>

          <TabPane tabId={TABS.ROBOT} role="tabpanel">
            <Robot />
          </TabPane>


          <TabPane
            tabId={TABS.BOOKMARK}
            role="tabpanel"
          >
            <Bookmark />
          </TabPane>

          <TabPane
            tabId={TABS.SETTINGS}
            role="tabpanel"
          >
            <Settings />
          </TabPane>

          <TabPane
            tabId={TABS.TEMPLATES}
            role="tabpanel"
          >
            <Templates />
          </TabPane>

        </TabContent>
      </div>
    </>
  );
};

export default Leftbar;
